module.exports = __webpack_public_path__ + "static/media/10.19e4f40c.png";